import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  ConversationSupportItemsResponseDataSchema,
  DataResponse,
  GetConversationSupportEntitiesSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetConversationSupportEntitiesSchema>
type Response = DataResponse<z.infer<typeof ConversationSupportItemsResponseDataSchema>>

const getConversationSupportEntitiesQueryKey = (query: Query) => [
  "conversationSupportEntities",
  query,
]

type Props = {
  query: Query
  enabled?: boolean
}

export const conversationSupportEntitiesQuery = ({ query, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getConversationSupportEntitiesQueryKey(query),
    enabled,
    queryFn: async () => {
      const response = await axios.get<Response>("/support/conversation", { params: query })
      return response.data.data
    },
  })
}
